(function () {
  'use strict';

  var MOBILE_MAX = 989;

  function isMobile() {
    return window.matchMedia('(max-width: ' + MOBILE_MAX + 'px)').matches;
  }

  function syncMobileBar() {
    var bar = document.getElementById('kitaboo-pdp-mobile-bar');
    if (!bar) return;

    if (!isMobile()) {
      bar.hidden = true;
      document.body.classList.remove('kitaboo-pdp-has-mobile-bar');
      return;
    }

    bar.hidden = false;
    document.body.classList.add('kitaboo-pdp-has-mobile-bar');

    var priceSource = document.querySelector('.kitaboo-pdp [id^="price-"] .price-item--regular, .kitaboo-pdp-details [id^="price-"] .price-item--regular');
    var priceTarget = bar.querySelector('.kitaboo-pdp-mobile-bar__price');
    if (priceSource && priceTarget) {
      priceTarget.textContent = priceSource.textContent.trim();
    }

    var addBtn = bar.querySelector('.kitaboo-pdp-mobile-bar__add');
    var buyBtn = bar.querySelector('.kitaboo-pdp-mobile-bar__buy');
    var mainAdd = document.querySelector('.kitaboo-pdp .product-form__submit');
    var mainBuy = document.querySelector('.kitaboo-pdp [data-buy-now]');

    if (addBtn && mainAdd) {
      addBtn.disabled = mainAdd.disabled;
      addBtn.textContent = mainAdd.textContent.trim();
    }
    if (buyBtn && mainBuy) {
      buyBtn.disabled = mainBuy.disabled;
    }
  }

  function initMobileBarActions() {
    var bar = document.getElementById('kitaboo-pdp-mobile-bar');
    if (!bar) return;

    var addBtn = bar.querySelector('.kitaboo-pdp-mobile-bar__add');
    var buyBtn = bar.querySelector('.kitaboo-pdp-mobile-bar__buy');

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var mainAdd = document.querySelector('.kitaboo-pdp .product-form__submit');
        if (mainAdd) mainAdd.click();
      });
    }
    if (buyBtn) {
      buyBtn.addEventListener('click', function () {
        var mainBuy = document.querySelector('.kitaboo-pdp [data-buy-now]');
        if (mainBuy) mainBuy.click();
      });
    }
  }

  function init() {
    if (!document.querySelector('.kitaboo-pdp')) return;
    initMobileBarActions();
    syncMobileBar();
    window.addEventListener('resize', syncMobileBar);

    var priceContainer = document.querySelector('.kitaboo-pdp [id^="price-"]');
    if (priceContainer && window.MutationObserver) {
      var observer = new MutationObserver(syncMobileBar);
      observer.observe(priceContainer, { childList: true, subtree: true, characterData: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
